<template>
  <div class="user-managment">
    <div class="relative">
      <SearchComponent
        ref="search"
        :condition="condition"
        :routeName="$route.name"
        @updateData="_updateData"
      >
        <template #default="{pickerOptions,searchData}">
          <div class="input-box">
            <span class="name">用户名称：</span>
            <div class="input">
              <el-input
                v-model="condition.name"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">手机号：</span>
            <div class="input">
              <el-input
                v-model="condition.phone"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box datepick">
            <span class="name">创建时间：</span>
            <div class="input">
              <el-date-picker
                v-model="condition.time"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">部门名称：</span>
            <div class="input">
              <el-input
                v-model="condition.departmentName"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">账号状态：</span>
            <div class="input">
              <el-select
                v-model="condition.status"
                placeholder="请输入"
                clearable
              >
                <el-option label="启用" value="1" />
                <el-option label="禁用" value="2" />
              </el-select>
            </div>
          </div>
          <el-button
            class="iconfont icon-sousuo"
            size="60"
            round
            @click="searchData"
          />
          <div class="operator" v-permission:add="$route.meta.permission">
            <el-button
              class="iconfont icon-tianjia sub-color"
              size="36"
              @click="editor"
              round
            />
            <span class="tips">新建用户</span>
          </div>
        </template>
      </SearchComponent>
      <TableComponent
        ref="table"
        :tableData="tableData"
        :routeName="$route.name"
        :pagination="pagination"
        @updateData="_updateData"
      >
        <template #btn="{handleSelectionDel}">
          <el-button
            size="98"
            class="del-color"
            @click="handleSelectionDel"
            v-permission:del="$route.meta.permission"
          >
            删除
          </el-button>
          <el-button
            size="98"
            class="sub-color"
            @click="openPop"
            v-permission:modify="$route.meta.permission"
          >
            重置密码
          </el-button>
          <el-button
            v-if="$store.state.entryType === 'admin'"
            class="export-color"
            @click="changeUser"
          >
            {{ mark === 'admin' ? '切换至入驻商家用户' : '切换至admin用户' }}
          </el-button>
        </template>
        <template #default="{handleDelete}">
          <el-table-column type="selection" align="center" width="130" fixed />
          <el-table-column
            prop="id"
            label="用户ID"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="name"
            label="用户名称"
            min-width="180"
            align="center"
          />
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="departmentName"
            label="部门名称"
            align="center"
            min-width="180"
          />
          <el-table-column label="角色" align="center" width="300">
            <template slot-scope="scope">
              <el-button
                round
                style="margin-bottom: .5rem;"
                :style="{ background: item.color }"
                v-for="item in scope.row.role"
                :key="item.roleId"
              >
                {{ item.roleName }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="loginNum"
            label="登录次数"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="time"
            label="创建时间"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="opearator"
            label="操作员"
            align="center"
            min-width="180"
          />
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            class-name="visible"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-button
                class="iconfont icon-bianji"
                size="36"
                round
                @click="editor(scope.row)"
                v-permission:editor="$route.meta.permission"
              />
              <el-button
                v-permission:disable="$route.meta.permission"
                class="iconfont icon-jinyong "
                :class="scope.row.status === '1' ? 'sub-color' : 'f3'"
                size="36"
                @click="changeAccountState(scope.row)"
                round
              />
              <el-button
                class="iconfont icon-shanchu"
                size="36"
                round
                @click="handleDelete(scope.$index, scope.row)"
                v-permission:del="$route.meta.permission"
              />
            </template>
          </el-table-column>
        </template>
      </TableComponent>
      <div class="mask" v-if="dialogVisible">
        <el-dialog
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :modal="false"
          custom-class="dialog"
          width="43rem"
          :center="true"
        >
          <el-form :model="form" label-width="auto">
            <el-form-item label="部门名称：">
              <div class="input-box">
                <div class="input">
                  <el-select
                    v-model="form.partId"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in filterDownData('partList')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="用户名称：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="form.name"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="手机号：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="form.phone"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="密码：" v-if="!form.id">
              <div class="input-box">
                <div class="input">
                  <el-input v-model="form.pwd" placeholder="请输入" clearable />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="角色添加：">
              <div class="input-box">
                <div class="input">
                  <el-select
                    v-model="form.roleId"
                    multiple
                    :multiple-limit="3"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in filterDownData('roleList')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="sub-color" size="98" @click="_saveAccountInfo">
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
      <div class="mask" v-if="dialogResPwd">
        <el-dialog
          :visible.sync="dialogResPwd"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :modal="false"
          custom-class="dialog vertical"
          width="31rem"
          :center="true"
        >
          <el-form
            label-width="auto"
            v-for="item in rest"
            :key="item.id"
            :model="item"
          >
            <el-form-item label="用户名：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="item.name"
                    placeholder="请输入"
                    clearable
                    disabled
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="新密码：">
              <div class="input-box">
                <div class="input">
                  <el-input v-model="item.pwd" placeholder="请输入" clearable />
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="sub-color" size="98" @click="restPwd">
              重置
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchCompnent'
import TableComponent from '../Components/TableComponent'
import updateData from 'mixins/updateData'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'userManagment',
  components: {
    SearchComponent,
    TableComponent
  },
  mixins: [updateData, filterDownData],
  data() {
    this.keyMap = {
      account_list: {
        name: 'tableData',
        account_id: 'id',
        account_name: 'name',
        account_phone: 'phone',
        admin_status: 'status',
        seller_status: 'status',
        founder: 'opearator',
        login_times: 'loginNum',
        part_name: 'departmentName',
        part_id: 'partId',
        role_id: 'roleId',
        add_time: 'time',
        role: 'role',
        color: 'color',
        role_name: 'roleName'
      }
    }
    return {
      mark: 'admin',
      dialogVisible: false,
      dialogResPwd: false,
      condition: {},
      pagination: {},
      tableData: [],
      form: {},
      resForm: {
        userName: ''
      }
    }
  },
  computed: {
    rest() {
      return this.$refs.table.multipleSelection
    }
  },
  created() {
    if (this.$store.state.entryType === 'admin') {
      this.mark = 'admin'
    } else {
      this.mark = ''
    }
    this._getAccountList({
      curpage: 1,
      mark: this.mark
    })
  },
  methods: {
    /**
     * 获取账号列表
     * @param params
     * @private
     */
    _getAccountList(params) {
      this.api.getAccountList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 编辑新建
     * @param item
     */
    editor(item) {
      if (item.id) {
        this.form = this.utils._cloneDeep(item)
      } else {
        this.form = {}
      }
      this.dialogVisible = true
    },
    /**
     * 保存账号信息
     * @param item
     * @private
     */
    _saveAccountInfo(item) {
      const { partId, name, phone, pwd, roleId, id } = item.id
        ? item
        : this.form
      const data = {
        account_id: id,
        part_id: partId,
        account_name: name,
        account_phone: phone,
        role_id: roleId.join(','),
        mark: this.mark,
        account_password: pwd
      }
      this.utils._checkSearchCondition(data)
      this.api.saveAccountInfo(data).then(() => {
        this.dialogVisible = false
        this.dialogResPwd = false
        this.$notify({
          type: 'success',
          message: '保存成功~！👌'
        })
        this._getAccountList({
          curpage: this.pagination.currentPage || 1,
          mark: this.mark
        })
      })
    },
    /**
     * 打开重置密码弹窗
     */
    openPop() {
      if (this.rest.length > 0) {
        this.dialogResPwd = true
      } else {
        this.$notify({
          type: 'warning',
          message: '请先选择用户~✌️'
        })
      }
    },
    /**
     * 重置密码
     */
    restPwd() {
      this.rest.forEach(v => {
        this._saveAccountInfo(v)
      })
    },
    /**
     * 账号状态改变
     * @param item
     */
    changeAccountState(item) {
      const status = item.status === '1' ? '2' : '1'
      this.api
        .changeAccountState({
          account_id: item.id,
          account_status: status,
          mark: this.mark
        })
        .then(() => {
          this.$notify({
            type: 'success',
            message: '状态改变成功！~🤣'
          })
          item.status = status
        })
    },
    /**
     * 切换用户列表
     */
    changeUser() {
      this.pagination.currentPage = 1
      this.mark = this.mark === 'admin' ? 'seller' : 'admin'
      this._getAccountList({
        curpage: 1,
        mark: this.mark
      })
    }
  }
}
</script>
